import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-warn",
  "use": "icon-warn-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-warn\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 870.4a358.4 358.4 0 1 0 0-716.8 358.4 358.4 0 0 0 0 716.8z m0 89.6a448 448 0 1 1 0-896 448 448 0 0 1 0 896z m-44.8-670.336h89.6l-7.424 267.008H473.6l-6.4-267.008zM512 608.896a44.8 44.8 0 1 1 0 89.6 44.8 44.8 0 0 1 0-89.6z\" p-id=\"3347\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol